/* eslint-disable react/jsx-no-useless-fragment */

import React, { useState } from 'react'
import Image from 'next/image'
import styles from './showFastagDetails.module.scss'
import { ARROW_DOWN_IMG, FASTAG_OWNER, FASTAG_STATUS, MAX_RECHARGE, MIN_RECHARGE, TOGGLE_ICON } from './constants'
import NoFastagFound from './noFastagFound'

const FastagDetails = ({ noFastagFound, balance, metaData, billerUserAccount, billerDetails }) => {
  const [showViewMoreContent, setShowViewMoreContent] = useState(false)
  return (
    <>
      {!noFastagFound ? (
        <>
          <div className={styles.fastagBalanceAndMore}>
            <div className={styles.currentBalance}>
              <p>Current balance</p>
              <span>₹{balance || '-'}</span>
            </div>
          </div>
          <div className={styles.viewDetails}>
            <div className={styles.viewDetailsHeading} onClick={() => setShowViewMoreContent(!showViewMoreContent)}>
              <p>View Details</p>
              <span>
                <Image
                  src={ARROW_DOWN_IMG}
                  alt={TOGGLE_ICON}
                  width={20}
                  height={20}
                  className={`${showViewMoreContent ? styles.toggelSvg : ''}`}
                />
              </span>
            </div>
            {showViewMoreContent && (
              <div className={styles.detailsVisible}>
                <div className={styles.viewDetail}>
                  <p>{FASTAG_OWNER}</p>
                  <span>{metaData?.customer_name || '-'}</span>
                </div>
                <div className={styles.viewDetail}>
                  <p>{FASTAG_STATUS}</p>
                  <span>{billerUserAccount?.is_active === true ? 'Active' : 'In-Active'}</span>
                </div>
                <div className={styles.viewDetail}>
                  <p>{MIN_RECHARGE}</p>
                  <span>₹{billerDetails?.min_amount || '-'}</span>
                </div>
                <div className={styles.viewDetail}>
                  <p>{MAX_RECHARGE}</p>
                  <span>₹{billerDetails?.max_amount || '-'}</span>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className={styles.noFastagContainer}>
        <NoFastagFound />
        </div>
      )}
    </>
  )
}

export default FastagDetails
